export const pushEcommerce = (data) => {
  try {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push(data);
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerGtmSelectIem = (item, itemListId, itemListName) => {
  try {
    pushEcommerce({
      event: 'select_item',
      ecommerce: {
        items: [item],
        currency: item.currency,
        item_list_id: itemListId,
        item_list_name: itemListName,
      },
    });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerRemoveFromCart = (gtmEcommerceItems) => {
  try {
    pushEcommerce({
      event: 'remove_from_cart',
      ecommerce: {
        items: gtmEcommerceItems,
        currency: gtmEcommerceItems[0].currency,
        value: gtmEcommerceItems.reduce(
          (p, v) => p + (v.price - v.discount) * v.quantity,
          0
        ),
      },
    });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerAddToCart = (gtmEcommerceItems) => {
  try {
    pushEcommerce({
      event: 'add_to_cart',
      ecommerce: {
        items: gtmEcommerceItems,
        currency: gtmEcommerceItems[0].currency,
        value: gtmEcommerceItems.reduce(
          (p, v) => p + (v.price - v.discount) * v.quantity,
          0
        ),
      },
    });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerGtmViewCart = (cart) => {
  try {
    pushEcommerce({
      event: 'view_cart',
      ecommerce: {
        currency: cart.currency,
        value: cart.gtmOrderRows.reduce(
          (p, v) => p + (v.price - v.discount) * v.quantity,
          0
        ),
        items: cart.gtmOrderRows,
      },
    });
  } catch (e) {
    console.log(e);
  }
};

let lastSearchTerm;
export const dataLayerSearch = (searchTerm) => {
  try {
    const term = (searchTerm || '').trim();
    // Mirror the quick-search debounce: only push once per distinct term (>= 2 chars).
    if (term.length < 2 || lastSearchTerm === term) {
      return;
    }
    lastSearchTerm = term;
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: 'search',
      search_term: term,
    });
  } catch (e) {
    console.log(e);
  }
};
